/* ============
 * ProductDeposits Module State
 * ============
 *
 * todo: add documentation here!
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productDeposit/state.js